import { SportsDataModelType } from 'src/api/config/sports/getSingleCustomizedSport';
import { CustomizedSportsState } from 'src/AppState/CmsState/SportsState/SportsState';

export interface SingleSportType {
    sportState: CustomizedSportsState,
    sportData: SportsDataModelType,
}

export class SingleSportState {
    constructor(
        private readonly props: SingleSportType,
    ) {}

    setActiveBgImg = async (screenType: string): Promise<void> => {
        try {
            await this.props.sportState.setActiveImg(this.props.sportData.id, screenType);
        } catch (error) {
            console.log('Error', error);
        }
    }

    onEdit = async (): Promise<void> => {
        this.props.sportState.setEditMode(true);
        await this.props.sportState.setEditSport(this.props.sportData);
    };

    onDelete = async (): Promise<void> => {
        try {
            await this.props.sportState.deleteSport(this.props.sportData.id);
        } catch (error) {
            console.log('Error', error);
        }
    }
}
